export const SET_TRIGGER = 'SET_TRIGGER';
export const RESET_TRIGGER = 'RESET_TRIGGER';
